import React from 'react';
import { Shield, Lock } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
import { CTAButton } from './ui/CTAButton';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function OfferSection() {
  return <AnimatedSection className="py-24 bg-navy-900 relative px-4 sm:px-6 lg:px-8 overflow-hidden" id="comprar" data-id="element-81">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-400/5 rounded-full blur-[120px] pointer-events-none" data-id="element-82" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-83">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6" data-id="element-84">
          Recupera el control de tu esfuerzo y deja de regalar tu excedente.
        </h2>

        <p className="text-xl text-slate-300 mb-12" data-id="element-85">
          Por el precio de una cena, obtén el sistema completo que construirá tu
          estabilidad financiera.
        </p>

        <div className="bg-navy-800 border border-gold-400/30 rounded-3xl p-8 sm:p-12 shadow-2xl relative overflow-hidden" id="precio" data-id="element-86">
          {/* Subtle inner glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-gradient-to-b from-gold-400/10 to-transparent" data-id="element-87" />

          <div className="relative z-10" data-id="element-88">
            <div className="mb-2 text-slate-400 uppercase tracking-widest text-sm font-bold" data-id="element-89">
              Inversión Única
            </div>
            <div className="mb-1" data-id="element-90">
              <span className="text-2xl text-slate-500 line-through decoration-red-400/70 decoration-2 font-heading" data-id="element-91">
                $39 USD
              </span>
            </div>
            <div className="text-6xl sm:text-7xl font-bold text-gold-400 mb-2 font-heading" data-id="element-92">
              $6.36 <span className="text-2xl text-gold-400/70" data-id="element-93">USD</span>
            </div>
            <div className="mb-10" data-id="element-94">
              <span className="inline-block bg-green-500/15 text-green-400 text-sm font-bold px-4 py-1.5 rounded-full border border-green-500/20" data-id="element-95">
                Ahorra un 84%
              </span>
            </div>

            <CTAButton href="https://pay.hotmart.com/L104758348U" className="w-full sm:w-auto text-lg sm:text-xl py-5 px-10 mb-6" onClick={() => trackAddToCart()} data-id="element-96">
              Descargar "El Excedente Fantasma"
            </CTAButton>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-slate-400 mt-6" data-id="element-97">
              <div className="flex items-center gap-2" data-id="element-98">
                <Lock className="w-4 h-4 text-gold-400" data-id="element-99" />
                <span data-id="element-100">Acceso inmediato tras la compra.</span>
              </div>
              <div className="hidden sm:block w-1 h-1 rounded-full bg-slate-600" data-id="element-101" />
              <div className="flex items-center gap-2" data-id="element-102">
                <Shield className="w-4 h-4 text-gold-400" data-id="element-103" />
                <span data-id="element-104">Pago seguro y cifrado.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}